/* ==========================================================================
   FF Cart Page — "Goes with X" smart upsells (wip314, 2026-08-14)
   REWRITTEN 2026-08-17 (wip332, "rail v1 upgrade"). WIP theme 191898976578 ONLY.
   Loads only on /cart, right after ff-cart.js (both <script defer>, so document order
   guarantees ff-cart.js's IIFE has already run and set window.FFCart.afterAdd /
   window.FFCart.refreshCartSections before anything here executes).

   WHAT CHANGED FROM wip314's VERSION, AND WHY:
   The old version fetched assets/ff-cart-upsells.json (a wip309 matching-engine export,
   capped at 5 pre-ranked companions per anchor) plus live /products/{handle}.js data per
   companion, then built every tile in JS. That worked for a single small "here's what
   goes with it" row, but couldn't support this wave's brief: ~6 real CATEGORY chips
   (Rugs / Coffee Tables / Accent Chairs / Ottomans / TV Stands / Lighting) each opening
   its own scrollable mini-collection, or the lifestyle-image-first rule -- the storefront
   /products/{handle}.js AJAX endpoint this file used to call does not expose the
   ffwip.card_image metafield at all (confirmed in the old code's own comment).
   sections/main-cart-items.liquid now does ALL of this server-side instead: the "Most
   Popular" grid (5 tiles, one per surviving category, curated so no two tiles share a
   category) and every category's mini-collection are real Liquid-rendered HTML at page
   load -- metafields/aspect are trivially available there, and there is no async gap to
   manage (no [hidden]-until-fetch-confirms-data dance; Liquid already knows whether
   there's real content before it ever sends the byte). So this file's job shrank to pure
   interaction: open the category overlay on a chip click (cloning the matching
   [data-ff-cat-panel]'s pre-rendered content in -- no fetch), close it, and the two
   add-to-cart handlers (single tile, add-all) -- both already worked directly off
   data-variant-id attributes in the DOM and needed no rewrite.
   REMOVED entirely (no longer reachable, no longer meaningful under server-rendering):
   ffGwFetchTable, ffGwFetchProduct, ffGwBuildTile, ffGwBuildViewMore, ffGwRenderGrid,
   ffGwRenderChips, ffGwInitOne, ffGwMoney, TYPE_LABEL, and the DOMContentLoaded fetch
   trigger. assets/ff-cart-upsells.json is left on disk, unreferenced -- not deleted, in
   case a future wave wants the anchor-specific matching engine back for something other
   than the default grid (this file just no longer reads it for that).
   ========================================================================== */
(function () {
  "use strict";

  /* ---------- category mini-collection overlay ----------
     Opens #ff-category-lightbox and clones the matching hidden [data-ff-cat-panel]'s
     ALREADY-RENDERED markup into the track -- the panel's cards are real server-rendered
     .ff-goeswith-tile elements (same snippet, same classes, same data-variant-id) so the
     tile-add delegated handler below needs zero changes to work inside the overlay too. */
  function ffCatOpen(catHandle, catLabel) {
    var overlay = document.getElementById("ff-category-lightbox");
    if (!overlay) return;
    var panel = document.querySelector('[data-ff-cat-panel="' + catHandle + '"]');
    var track = overlay.querySelector("[data-ff-cat-track]");
    var titleEl = overlay.querySelector(".ff-cat-lightbox-title");
    if (!panel || !track) return;
    track.innerHTML = panel.innerHTML; /* clone, not move -- the source panel stays intact
                                           for the next open (e.g. after a section refresh
                                           re-renders it fresh) */
    if (titleEl) titleEl.textContent = catLabel || "";
    overlay.hidden = false;
    track.scrollLeft = 0;
  }
  function ffCatClose() {
    var overlay = document.getElementById("ff-category-lightbox");
    if (overlay) overlay.hidden = true;
    document.querySelectorAll(".ff-goeswith-chip").forEach(function (chip) {
      var isPopular = !chip.dataset.ffGwCat;
      chip.classList.toggle("is-active", isPopular);
      chip.setAttribute("aria-pressed", isPopular ? "true" : "false");
    });
  }

  /* ---------- chip clicks (delegated -- survives every AJAX section refresh) ----------
     "Most Popular" chip (empty data-ff-gw-cat, the default/resting state -- the visible
     .ff-goeswith-grid never changes) just closes the overlay if one happens to be open
     and re-marks itself active. A real category chip marks itself active and opens the
     mini-collection overlay for that category. */
  document.addEventListener("click", function (event) {
    var chip = event.target.closest(".ff-goeswith-chip");
    if (!chip) return;
    var catHandle = chip.dataset.ffGwCat;
    if (!catHandle) {
      ffCatClose();
      return;
    }
    document.querySelectorAll(".ff-goeswith-chip").forEach(function (c) {
      c.classList.toggle("is-active", c === chip);
      c.setAttribute("aria-pressed", c === chip ? "true" : "false");
    });
    var label = chip.textContent.trim();
    ffCatOpen(catHandle, label);
  });

  /* ---------- overlay close: X button, backdrop click, Esc ---------- */
  document.addEventListener("click", function (event) {
    if (event.target.closest(".ff-cat-lightbox-close") || event.target.id === "ff-category-lightbox") {
      ffCatClose();
    }
  });
  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") return;
    var overlay = document.getElementById("ff-category-lightbox");
    if (overlay && !overlay.hidden) ffCatClose();
  });

  /* ---------- single-tile add (small dark "+" icon) ----------
     Unchanged from wip314: reads data-variant-id straight off the clicked button, no
     dependency on how/where the tile was rendered -- works identically for a
     server-rendered "Most Popular" tile and a cloned mini-collection card. */
  document.addEventListener("click", function (event) {
    var btn = event.target.closest(".ff-goeswith-tile-add");
    if (!btn || btn.disabled) return;
    event.preventDefault();
    var variantId = btn.dataset.variantId;
    if (!variantId) return;
    var originalHtml = btn.innerHTML;
    btn.disabled = true;
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: 1, sections: "cart-drawer,cart-icon-bubble" })
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status) {
          console.error("FF cart: goes-with tile add failed", response);
          btn.disabled = false;
          btn.innerHTML = originalHtml;
          return;
        }
        btn.classList.add("ff-added");
        btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';
        if (window.FFUpsellTrack) {
          var addedTile = btn.closest(".ff-goeswith-tile");
          if (addedTile) window.FFUpsellTrack.trackAdd(addedTile, 1);
        }
        if (window.FFCart && window.FFCart.afterAdd) window.FFCart.afterAdd(response);
        window.setTimeout(function () {
          if (window.FFCart && window.FFCart.refreshCartSections) window.FFCart.refreshCartSections();
        }, 900);
      })
      .catch(function (e) {
        console.error("FF cart: goes-with tile add failed", e);
        btn.disabled = false;
        btn.innerHTML = originalHtml;
      });
  });

  /* ---------- Add all (the "Most Popular" grid only) ----------
     Scoped to .ff-goeswith-grid specifically, NOT the whole .ff-goeswith-block --
     .ff-cat-panels (the hidden per-category mini-collection source data) is a sibling
     inside the same block and also contains .ff-goeswith-tile[data-variant-id] elements;
     querying the whole block would silently add every product from every category, not
     just the 5 visible "Most Popular" picks. The addall row's own count/price text is
     rendered once, server-side, and never changes client-side (the grid it summarizes
     never changes either -- category browsing happens in the separate overlay), so
     unlike wip314's version there is no render-on-filter-change step to reimplement. */
  document.addEventListener("click", function (event) {
    var btn = event.target.closest("[data-ff-gw-addall-btn]");
    if (!btn || btn.disabled) return;
    event.preventDefault();
    var container = btn.closest(".ff-goeswith-block");
    if (!container) return;
    var grid = container.querySelector(".ff-goeswith-grid");
    if (!grid) return;
    var tiles = grid.querySelectorAll(".ff-goeswith-tile[data-variant-id]");
    var items = [];
    tiles.forEach(function (t) { items.push({ id: parseInt(t.dataset.variantId, 10), quantity: 1 }); });
    if (!items.length) return;
    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = "Adding...";
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: items, sections: "cart-drawer,cart-icon-bubble" })
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        btn.disabled = false;
        btn.textContent = originalText;
        if (response.status) { console.error("FF cart: add-all failed", response); return; }
        if (window.FFUpsellTrack) {
          tiles.forEach(function (t) { window.FFUpsellTrack.trackAdd(t, 1); });
        }
        if (window.FFCart && window.FFCart.afterAdd) window.FFCart.afterAdd(response);
        if (window.FFCart && window.FFCart.refreshCartSections) window.FFCart.refreshCartSections();
      })
      .catch(function (e) {
        btn.disabled = false;
        btn.textContent = originalText;
        console.error("FF cart: add-all failed", e);
      });
  });

  /* ---------- re-init after every AJAX section refresh ----------
     Content is server-rendered fresh on every refresh already (no fetch to re-run here)
     -- the only thing worth resetting is a category overlay that happened to be open
     when the refresh landed (its cloned content would otherwise go stale against the
     freshly re-rendered [data-ff-cat-panel] source). Exposed as window.FFCart.initGoesWith
     for backward compatibility with the existing call site in assets/ff-cart.js
     (refreshCartSections already calls it; not touching that file for this). */
  function initGoesWith() {
    ffCatClose();
  }

  window.FFCart = window.FFCart || {};
  window.FFCart.initGoesWith = initGoesWith;
})();
